export enum ObservationStatusState {
    DRAFT = 'DRAFT',
    PENDING_REVIEW = 'PENDING_REVIEW',
    CHANGES_REQUESTED = 'CHANGES_REQUESTED',
    APPROVED = 'APPROVED',
    SENT = 'SENT',
}

export const InReviewStates = [
    ObservationStatusState.PENDING_REVIEW,
    ObservationStatusState.CHANGES_REQUESTED,
    ObservationStatusState.APPROVED,
];
